<ng-container *ngIf="loaded$ | async">
    <da-maintenance-overlay *ngIf="(isNotCountrySelectionPage$ | async)"></da-maintenance-overlay>
    <da-cookie-consent-overlay *ngIf="(isNotCountrySelectionPage$ | async) && (isOnlyDomain$ | async)=== false" (closeOverlay)="closeCookieOverlay($event)"></da-cookie-consent-overlay>
    <da-global-notification *ngIf="showCookieNotification$ | async"></da-global-notification>
    <da-header *ngIf="(isNotError500Page$ | async) && (showHeader$ | async)"></da-header>
    <da-breadcrumb *ngIf="(isNotError500Page$ | async) && (isNotCountrySelectionPage$ | async) && (showBreadcrumbs$ | async) && portalId !== 'de-ext'">
    </da-breadcrumb>
    <router-outlet></router-outlet>
    <da-contact-us-section *ngIf="(isNotCountrySelectionPage$ | async) && (showContact$ | async)" [portalHubSpotId]="portalHubSpotId"> </da-contact-us-section>
    <da-footer *ngIf="(isNotError500Page$ | async) && (showFooter$ | async)" [portalImprintUrl]="portalImprintUrl"></da-footer>
</ng-container>
